import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ScheduleService } from 'src/app/services/schedule.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-find-partner-chat-history',
  templateUrl: './find-partner-chat-history.component.html',
  styleUrls: ['./find-partner-chat-history.component.scss'],
  providers: [MessageService]
})
export class FindPartnerChatHistoryComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  userId: string;
  opponentUserId: string;
  conversationId: string;
  messagesList: any[] = [];
  totalRecords: number = 0;
  pageNumberFirst: number = 1;
  pageLimitFirst: number = 10;
  paginationOption = environment.pagination;
  loading: boolean = false;
  public hide: boolean = true;

  constructor(
    private activeroute: ActivatedRoute,
    private scheduleService: ScheduleService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.userId = this.activeroute.snapshot.params['userId'];
    this.opponentUserId = this.activeroute.snapshot.params['opponentUserId'];
    this.loadConversation();
  }

  loadConversation() {
    this.loading = true;
    this.scheduleService
      .getPartnerPrivateConversation(this.userId, this.opponentUserId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.conversationId = data.data.id;
          this.pageNumberFirst = 1;
          this.loadChatHistory();
        },
        err => {
          this.loading = false;
          this.messageService.add({
            key: 'toastmsg',
            severity: 'error',
            summary: 'Error',
            detail: err.error?.message || 'Failed to load conversation'
          });
        }
      );
  }

  loadChatHistory(event?: any) {
    if (event) {
      this.pageLimitFirst = event.rows;
      this.pageNumberFirst = (event.first / event.rows) + 1;
    }

    this.loading = true;
    const query = `pageSize=${this.pageLimitFirst}&pageNumber=${this.pageNumberFirst}`;
    this.scheduleService
      .getPartnerChatHistory(this.conversationId, query)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          this.loading = false;
          this.messagesList = res.data;
          this.totalRecords = res.totalCount || res.data?.length || 0;
        },
        err => {
          this.loading = false;
          this.messageService.add({
            key: 'toastmsg',
            severity: 'error',
            summary: 'Error',
            detail: err.error?.message || 'Failed to load chat history'
          });
        }
      );
  }

  isAttachment(content: string): boolean {
    if (!content) return false;
    const extensions = ['.mp4', '.mov', '.avi', '.png', '.jpg', '.jpeg', '.gif', '.pdf', '.csv', '.xlsx', '.zip', '.txt'];
    return extensions.some(ext => content.toLowerCase().endsWith(ext));
  }

  isImage(content: string): boolean {
    if (!content) return false;
    const extensions = ['.png', '.jpg', '.jpeg', '.gif'];
    return extensions.some(ext => content.toLowerCase().endsWith(ext));
  }

  isVideo(content: string): boolean {
    if (!content) return false;
    const extensions = ['.mp4', '.webm', '.ogg', '.mov'];
    return extensions.some(ext => content.toLowerCase().endsWith(ext));
  }

  getAvatarColor(name: string): string {
    if (!name) return '#689f38';
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = [
      '#4e73df', '#1cc88a', '#36b9cc', '#f6c23e', '#e74a3b',
      '#5a5c69', '#fd7e14', '#6f42c1', '#e83e8c', '#20c997'
    ];
    return colors[Math.abs(hash) % colors.length];
  }

  getInitials(firstName: string, lastName: string): string {
    const f = firstName ? firstName.trim().charAt(0).toUpperCase() : '';
    const l = lastName ? lastName.trim().charAt(0).toUpperCase() : '';
    return f + l || '?';
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
